import React, { useEffect, useState } from "react";
import _ from "lodash";
import InputText from "../Input/text";
import { requestAuthPatch, requestAuthPost } from "../../api/authInstance";
import { useAuth } from "../auth/authContext";
import InformationSheet from "../Sheet/InformationSheet";
import { toastPromise } from "../../utils/Utils";
import FormInput from "../Input/FormInput";
import InputSelect from "../Input/InputSelect";
import Button from "../Button/Button";
import FormTextArea from "../Input/FormTextArea";
import "react-spring-bottom-sheet/dist/style.css";
import ModalBottom from "./ModalBottom";

export default function ModalUser({
  showModal,
  setShowModal,
  propsModal,
  setData,
  data,
  fetchUsers,
}) {
  const { userData } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const { type, outlets, roles } = propsModal;
  const [idOutlet, setIdOutlet] = useState(
    showModal && type === "edit"
      ? propsModal.data?.userOutlet[0].outlet?.id
      : null,
  );
  const defaultInvalid = {
    phone: null,
  };
  const [invalid, setInvalid] = useState(defaultInvalid);
  const [idRole, setIdRole] = useState(
    showModal && type === "edit"
      ? propsModal.data?.role[0]?.userRole?.id
      : null,
  );

  const options = {
    roles: _.map(
      _.filter(
        roles,
        (role) =>
          role.applicationType === "WALLET" && !role.roleName.includes("Admin"),
      ),
      (item) => ({
        value: item.id,
        label: item.roleName,
      }),
    ),
    outlets: _.map(outlets, (item) => ({
      value: item.id,
      label: item.name,
    })),
  };

  // sheet state
  const [sheetDetail, setSheetDetail] = useState({
    title: "",
    detail: "",
    open: false,
  });

  const handleInvalidChange = (name, value) => {
    setInvalid((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (type === "add") {
      setIdOutlet(null);
      setIdRole(null);
      setData({});
    } else if (type === "edit") {
      setIdOutlet(propsModal.data?.userOutlet[0].outlet?.id);
      setIdRole(propsModal.data?.role[0]?.userRole?.id);
    }
  }, [type]);

  const onSubmit = async (data) => {
    setIsLoading(false);
    const formData = {
      ...data,
      profile: data.profile || {},
      applicationType: "WALLET",
      password: "123456", // Consider generating a random password or requiring user input
      retailer: userData?.outlet?.retailer?.id,
      outlet: idOutlet,
      role: idRole,
    };

    const requiredFields = [
      { field: "firstName", message: "nama depan" },
      { field: "lastName", message: "nama belakang" },
      { field: "phone", message: "nomor whatsapp" },
    ];
    let hasInvalid = false;

    requiredFields.forEach(({ field, message }) => {
      const value = formData?.profile?.[field] || "";
      if (value.trim() === "") {
        handleInvalidChange(field, `${message} harus diisi`);
        hasInvalid = true;
      } else {
        handleInvalidChange(field, "");
      }
    });

    try {
      if (type === "add") {
        if (hasInvalid) return;
        await toastPromise("Adding User", handleAdd(formData));
      } else if (type === "edit") {
        if (hasInvalid) return;
        await toastPromise("Updating User", handleEdit(formData));
      } else {
        setIsLoading(false);
        throw new Error("Invalid operation type");
      }

      await fetchUsers();
      setIdOutlet(null);
      setIdRole(null);
      setData({});
      setShowModal(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error submitting user data:", error);
    }
  };

  const handleAdd = async (formData) => {
    return new Promise(async (resolve, reject) => {
      await requestAuthPost("users", {
        ...formData,
        ...formData?.profile,
        phone: `62${formData.profile.phone}`,
      })
        .then((res) => {
          if (res.error) {
            reject(res.error);
          } else {
            if (!_.isEmpty(res)) resolve(res?.data?.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
      setShowModal(false);
    });
  };

  const handleEdit = async (formData) => {
    return new Promise(async (resolve, reject) => {
      await requestAuthPatch(`users/${formData.id}`, {
        ...formData,
        ...formData.profile,
        phone: `62${formData.profile.phone}`,
      })
        .then((res) => {
          if (res.error) {
            reject(res.error);
          } else {
            if (!_.isEmpty(res)) resolve(res?.data?.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
      setShowModal(false);
    });
  };

  return (
    <>
      {/* Modal ADD User */}
      <ModalBottom
        showModal={showModal}
        setShowModal={setShowModal}
        onClose={() => setInvalid(defaultInvalid)}
        defaultHeight={0.9}
        title="Member"
        footer={
          <div className="">
            <div className="flex flex-wrap justify-end space-x-2">
              <Button
                onClick={() => {
                  setShowModal(false);
                  setInvalid(defaultInvalid);
                }}
                disabled={isLoading}
                label="Close"
                variant="default"
              />
              <Button
                onClick={() => onSubmit(data)}
                label="Save"
                disabled={isLoading}
                variant="gradient"
              />
            </div>
          </div>
        }
      >
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-4">
            <FormInput
              name="firstName"
              placeholder="Nama Depan"
              disabled={isLoading}
              label="Nama Depan"
              onFocus={() => handleInvalidChange("firstName", "")}
              value={data?.profile?.firstName ?? ""}
              onChange={(e) =>
                setData((prevState) => ({
                  ...prevState,
                  profile: {
                    ...prevState?.profile,
                    firstName: e.target.value,
                  },
                }))
              }
              isInvalid={invalid.firstName}
              validationString="required"
            />
            <FormInput
              name="lastName"
              placeholder="Nama Belakang"
              label="Nama Belakang"
              disabled={isLoading}
              onFocus={() => handleInvalidChange("lastName", "")}
              isInvalid={invalid.lastName}
              value={data?.profile?.lastName ?? ""}
              onChange={(e) =>
                setData((prevState) => ({
                  ...prevState,
                  profile: {
                    ...prevState?.profile,
                    lastName: e.target.value,
                  },
                }))
              }
              validationString="required"
            />
          </div>
          <InputText
            name="identifier"
            label="Email Pengguna"
            placeholder="User Email"
            type="email"
            disabled={isLoading}
            value={
              data.identifier
                ? !data.identifier.startsWith("62")
                  ? data.identifier
                  : ""
                : ""
            }
            onChange={(e) =>
              setData((prevState) => ({
                ...prevState,
                identifier: e.target.value,
              }))
            }
            validationString="email"
            errorMessage={"Invalid email address"}
          />
          <InputText
            name="phone"
            placeholder="Nomor WhatsApp"
            label="Nomor WhatsApp"
            type="tel"
            disabled={isLoading}
            onFocus={() => handleInvalidChange("phone", "")}
            value={
              data?.profile?.phone
                ? data?.profile?.phone.startsWith("628")
                  ? data?.profile?.phone.replace(/^628/, "8")
                  : data?.profile?.phone
                : ""
            }
            onChange={(e) => {
              let value = e.target.value;
              value = value.replace(/\D/g, "");
              if (value.startsWith("08")) {
                value = value.replace(/^08/, "8");
              } else if (value.startsWith("628")) {
                value = value.replace(/^628/, "8");
              }
              setData((prevState) => ({
                ...prevState,
                profile: {
                  ...prevState?.profile,
                  phone: value,
                },
              }));
            }}
            isInvalid={invalid.phone}
            validationString="+62|required"
            prefix="+62"
            errorMessage={"Invalid phone number"}
          />
          <FormTextArea
            name="address"
            placeholder="User Address Detail"
            className={`form-input w-full`}
            label="Alamat Lengkap"
            type="text"
            disabled={isLoading}
            rows={4}
            value={data?.profile?.address ?? ""}
            onChange={(e) =>
              setData((prevState) => ({
                ...prevState,
                profile: {
                  ...prevState?.profile,
                  address: e.target.value,
                },
              }))
            }
          />
          <InputSelect
            name="role"
            label="Role"
            placeholder="Role"
            relative
            disabled={isLoading}
            shouldScrollIntoView
            options={[{ value: null, label: "Choose Role" }].concat(
              options.roles,
            )}
            value={
              _.find(options.roles, {
                value: idRole,
              }) ?? null
            }
            onChange={(e) => setIdRole(e.value)}
          />

          <InputSelect
            name="outlet"
            label="Assign To Outlet"
            placeholder="Outlet"
            disabled={isLoading}
            options={options.outlets}
            relative
            shouldScrollIntoView
            value={
              _.find(options.outlets, {
                value: idOutlet,
              }) ?? null
            }
            onChange={(e) => setIdOutlet(e.value)}
          />
        </div>
      </ModalBottom>
      <InformationSheet
        sheetDetail={sheetDetail}
        setSheetDetail={setSheetDetail}
      />
    </>
  );
}
